var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",staticStyle:{"column-gap":"10px"}},[_c('field-single',{attrs:{"config":_vm.confFrom},model:{value:(_vm.vFrom),callback:function ($$v) {_vm.vFrom=$$v},expression:"vFrom"}}),_c('field-single',{attrs:{"config":_vm.confTo},model:{value:(_vm.vTo),callback:function ($$v) {_vm.vTo=$$v},expression:"vTo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }